<div class="multi-select-container">
  <button
    nz-button
    nz-popover
    nzPopoverTrigger="click"
    [nzPopoverContent]="contentTemplate"
    nzPopoverPlacement="bottomLeft"
    class="multi-select-header"
    (nzPopoverVisibleChange)="popoverChange()"
    [ngClass]="{ selected: filterSelected }"
  >
    {{ headerText }}
    <i nz-icon [nzType]="popoverOpen ? 'up' : 'down'" class="down-arrow"></i>
  </button>
  <ng-template #contentTemplate>
    <div class="multi-select-dropdown">
      <nz-input-group
        [nzPrefix]="suffixIconSearch"
        nzSize="small"
        class="search-box"
      >
        <input
          type="text"
          nz-input
          placeholder="Input Search Text"
          [formControl]="queryField"
        />
      </nz-input-group>
      <ng-template #suffixIconSearch>
        <i nz-icon nzType="search"></i>
      </ng-template>
      <br />
      <div>
        <nz-checkbox-wrapper
          style="width: 100%"
          (nzOnChange)="onChanges($event)"
          class="check-box-group"
        >
          <div>
            <div
              *ngFor="let val of data.list"
              [ngClass]="{ hide: isHidden(val.label) }"
            >
              <label
                nz-checkbox
                nzValue="{{ val.value }}"
                [(ngModel)]="val.checked"
                [nzDisabled]="val.disabled"
                class="checkbox-label"
                >{{ val.label }}</label
              >
              <img
                class="pad-icon"
                *ngIf="val.excluded == true"
                [src]="assets + '/icon-excluded.png'"
                title="Excluded from consensus"
              />
            </div>
          </div>
        </nz-checkbox-wrapper>
        <div nz-menu-divider></div>
        <div class="reset" (click)="resetAll()">
          <va-icon size="small" name="redo" class="fa-sm reset-icon"></va-icon>
          <label class="reset-lbl">Reset</label>
        </div>
      </div>
    </div>
  </ng-template>
</div>
